module.exports = __webpack_public_path__ + "static/succulent-2-d31210f30143a031cb1d7ac0509d4d20.png";